const DISMISSIBLE = 'dismissible'
const PERSISTENT = 'persistent'
const COLLAPSIBLE = 'collapsible'

export default {
    DISMISSIBLE,
    PERSISTENT,
    COLLAPSIBLE
}